/**
 * Volta Parça Fabrika Header — mega menu, mobil drawer, arama, klavye erişilebilirliği
 * Sınıf adları: voltaparcafabrika-mega-menu__panel--open, is-open (accordion)
 */
(function () {
  'use strict';

  var header = document.getElementById('voltaparcafabrika-site-header');
  if (!header) return;

  var mobileToggle   = header.querySelector('[data-voltaparcafabrika-mobile-toggle]');
  var mobileDrawer   = document.getElementById('voltaparcafabrika-mobile-drawer');
  var mobilePanel    = mobileDrawer && mobileDrawer.querySelector('.voltaparcafabrika-mobile-drawer__panel');
  var searchToggle   = header.querySelector('[data-voltaparcafabrika-search-toggle]');
  var searchPanel    = document.getElementById('voltaparcafabrika-header-search');
  var searchInput    = document.getElementById('voltaparcafabrika-header-search-input');
  var lastFocused    = null;

  function isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  /* ── Mega menu (desktop) ── */

  function closeMegaPanels(exceptItem) {
    header.querySelectorAll('[data-voltaparcafabrika-mega-item]').forEach(function (item) {
      if (item === exceptItem) return;
      item.removeAttribute('data-open');
      var trigger = item.querySelector('[data-voltaparcafabrika-mega-trigger]');
      var panel   = item.querySelector('.voltaparcafabrika-mega-menu__panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel)   panel.classList.remove('voltaparcafabrika-mega-menu__panel--open');
    });
  }

  header.querySelectorAll('[data-voltaparcafabrika-mega-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-voltaparcafabrika-mega-trigger]');
    var panel   = item.querySelector('.voltaparcafabrika-mega-menu__panel');
    if (!trigger || !panel) return;

    function openPanel() {
      closeMegaPanels(item);
      item.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
      panel.classList.add('voltaparcafabrika-mega-menu__panel--open');
    }

    function closePanel() {
      item.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.classList.remove('voltaparcafabrika-mega-menu__panel--open');
    }

    /* Desktop: hover aç/kapat */
    item.addEventListener('mouseenter', function () {
      if (isDesktop()) openPanel();
    });
    item.addEventListener('mouseleave', function () {
      if (isDesktop()) closePanel();
    });

    /* Click: A tag'ı desktop'ta navigate eder, menüyü kapıyorsa klavye */
    trigger.addEventListener('click', function (e) {
      if (isDesktop() && trigger.tagName === 'A') return; // navigate
      if (item.hasAttribute('data-open')) closePanel();
      else openPanel();
    });

    /* Klavye */
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePanel(); trigger.focus(); }
      if (e.key === 'ArrowDown') {
        e.preventDefault(); openPanel();
        var first = panel.querySelector('a');
        if (first) first.focus();
      }
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePanel(); trigger.focus(); }
    });
  });

  /* ── Mobil accordion ── */

  function closeMobileAccordions() {
    if (!mobileDrawer) return;
    mobileDrawer.querySelectorAll('.voltaparcafabrika-mega-menu__accordion-item').forEach(function (item) {
      var trigger  = item.querySelector('[data-voltaparcafabrika-accordion-trigger]');
      var panelId  = trigger && trigger.getAttribute('aria-controls');
      var panel    = panelId ? document.getElementById(panelId) : null;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel)   panel.hidden = true;
      item.classList.remove('is-open');
    });
  }

  if (mobileDrawer) {
    mobileDrawer.querySelectorAll('[data-voltaparcafabrika-accordion-trigger]').forEach(function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel   = panelId ? document.getElementById(panelId) : null;
      var item    = trigger.closest('.voltaparcafabrika-mega-menu__accordion-item');
      if (!panel || !item) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        closeMobileAccordions();
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trigger.click(); }
      });
    });
  }

  /* ── Mobile drawer ── */

  function openMobileDrawer() {
    if (!mobileDrawer || !mobileToggle) return;
    lastFocused = document.activeElement;
    mobileDrawer.hidden = false;
    mobileDrawer.setAttribute('aria-hidden', 'false');
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileToggle.setAttribute('aria-label', 'Menüyü kapat');
    document.body.classList.add('vp-drawer-open');
    if (mobilePanel) mobilePanel.focus();
  }

  function closeMobileDrawer() {
    if (!mobileDrawer || !mobileToggle) return;
    mobileDrawer.hidden = true;
    mobileDrawer.setAttribute('aria-hidden', 'true');
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.setAttribute('aria-label', 'Menüyü aç');
    document.body.classList.remove('vp-drawer-open');
    closeMobileAccordions();
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    else if (mobileToggle) mobileToggle.focus();
  }

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', function () {
      if (mobileDrawer.hidden) openMobileDrawer();
      else closeMobileDrawer();
    });
    mobileDrawer.querySelectorAll('[data-voltaparcafabrika-mobile-close]').forEach(function (el) {
      el.addEventListener('click', closeMobileDrawer);
    });
    if (mobilePanel) {
      mobilePanel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusable = Array.from(mobilePanel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) { return el.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
  }

  /* ── Search overlay ── */

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!searchPanel.hidden) { closeSearch(); return; }
      searchPanel.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      if (searchInput) searchInput.focus();
    });
  }

  /* ── Predictive Search ── */
  var searchTimers = {};
  function fetchPredictiveSearch(inputEl, resultsEl) {
    var term = inputEl.value.trim();
    if (term.length < 3) {
      resultsEl.style.display = 'none';
      resultsEl.innerHTML = '';
      return;
    }
    clearTimeout(searchTimers[inputEl.id]);
    searchTimers[inputEl.id] = setTimeout(function() {
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=4')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.resources.results.products;
          if (!products || products.length === 0) {
            resultsEl.style.display = 'block';
            resultsEl.innerHTML = '<div class="vp-predictive-search__item" style="color:var(--vp-text-muted);justify-content:center;">Sonuç bulunamadı.</div>';
            return;
          }
          var html = '';
          products.forEach(function(p) {
            var imgHtml = p.image ? '<img src="' + p.image.replace('.jpg', '_80x80.jpg').replace('.png', '_80x80.png') + '" alt="">' : '<svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>';
            html += '<a href="' + p.url + '" class="vp-predictive-search__item">' +
                      '<div class="vp-predictive-search__image">' + imgHtml + '</div>' +
                      '<div class="vp-predictive-search__info">' +
                        '<div class="vp-predictive-search__title">' + p.title + '</div>' +
                        '<div class="vp-predictive-search__price">' + p.price + '</div>' +
                      '</div>' +
                    '</a>';
          });
          html += '<a href="/search?q=' + encodeURIComponent(term) + '" class="vp-predictive-search__all">Tüm sonuçları gör</a>';
          resultsEl.innerHTML = html;
          resultsEl.style.display = 'block';
        });
    }, 300);
  }

  var deskInput = document.getElementById('voltaparcafabrika-header-search-input');
  var deskRes   = document.getElementById('desktop-predictive-search');
  if (deskInput && deskRes) {
    deskInput.addEventListener('input', function() { fetchPredictiveSearch(deskInput, deskRes); });
  }

  var mobInput = document.getElementById('voltaparcafabrika-mobile-search-input');
  var mobRes   = document.getElementById('mobile-predictive-search');
  if (mobInput && mobRes) {
    mobInput.addEventListener('input', function() { fetchPredictiveSearch(mobInput, mobRes); });
  }

  /* ── Global close ── */

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMobileDrawer();
    closeMegaPanels(null);
    closeSearch();
  });

  document.addEventListener('click', function (e) {
    if (deskRes && deskRes.style.display === 'block' && !deskRes.contains(e.target) && e.target !== deskInput) {
      deskRes.style.display = 'none';
    }
    if (mobRes && mobRes.style.display === 'block' && !mobRes.contains(e.target) && e.target !== mobInput) {
      mobRes.style.display = 'none';
    }

    if (header.contains(e.target) || (mobileDrawer && mobileDrawer.contains(e.target))) {
      if (searchPanel && !searchPanel.hidden) {
        if (!searchPanel.contains(e.target) && !(searchToggle && searchToggle.contains(e.target))) closeSearch();
      }
      if (isDesktop() && !e.target.closest('[data-voltaparcafabrika-mega-item]')) closeMegaPanels(null);
      return;
    }
    closeMegaPanels(null);
    closeSearch();
  });
})();
